<template>
  <TelexComponent ref="telexComponent" :speed="50"></TelexComponent>
</template>


<script>
import TelexComponent from "@/components/telex/TelexComponent.vue";

export default {
  name: "OscarPoolResultsNewsFeed",
  components: {TelexComponent},
  methods: {
    setMessages(messages) {
      // replace 'bold' tag with a style that's slightly less bold
      const formattedMessages = messages.map(m => m = m.replaceAll(`<b>`, `<span style="font-weight: 600;">`).replaceAll(`</b>`, `</span>`));

      this.$refs.telexComponent.setMessages(formattedMessages);
    },
  }
}
</script>


<style scoped>
</style>